export const goToLandingPage = () => {
    history.back();
};
